// extracted by mini-css-extract-plugin
module.exports = {"fab":"Header_fab__2vG9F","fas":"Header_fas___wcqS","vertical_line":"Header_vertical_line__kTKud"};